export function adaptInsightsCtaBlock(
  entry: Record<string, unknown>,
  _baseUrl: string,
): Record<string, unknown> {
  return {
    heading: (entry['heading'] as string) ?? '',
    body: (entry['body'] as string) ?? undefined,
    buttonLabel: (entry['buttonLabel'] as string) ?? '',
    buttonHref: (entry['buttonHref'] as string) ?? '',
    placement: (entry['placement'] as string) ?? 'sidebar',
  };
}
